import { BLOGS } from "../constants/BlogConstant";

export const getTags = (blogs: any[]) => {
  const tags = blogs.map((blog) => blog.tag);
  return Array.from(new Set(tags));
};

export const filterBlogsByTag = (blogs: any[], tag: string) => {
  return blogs.filter((blog) => blog.tag === tag);
};

export const getBlogCategories = (blogs: any[]) => {
  const categories = blogs.map((blog) => blog.category);
  const uniqueCategories = Array.from(new Set(categories));

  const categoryObjects = [];

  for (const category of uniqueCategories) {
    const count = blogs.filter((blog) => blog.category === category).length;
    if (category) categoryObjects.push({ name: category, count });
  }
  return categoryObjects;
};

export const filterBlogsByCategory = (blogs: any[], category: string) => {
  return blogs.filter((blog) => blog.category === category);
};

export const getRecentBlogs = (blogs: any[]) => {
  const sortedBlogs = blogs.sort((a, b) => {
    return new Date(b.publishedDate).getTime() - new Date(a.publishedDate).getTime();
    });
  return sortedBlogs.slice(0, 3);
};

export const filterBlogs = (query: string) => {
  const lowerCaseQuery = query.toLowerCase();
  return BLOGS.filter(
    (blog) =>
      blog.title.toLowerCase().includes(lowerCaseQuery) || 
      blog.tag.toLowerCase().includes(lowerCaseQuery) ||
      (blog.category && blog.category.toLowerCase().includes(lowerCaseQuery))
  );
};